import { setWorkerUrl } from "maplibre-gl";

/**
 * MapLibre (used only by the public proposal map – Kartverket raster, no vendor token) spawns a module worker.
 * CRA/webpack cannot resolve the package-relative `new URL(..., import.meta.url)` it uses, so the worker and its
 * shared chunk are served verbatim from /public/vendor/maplibre and the URL is pinned once here.
 */
let done = false;
export const ensureMapLibreWorker = () => {
  if (done) return;
  done = true;
  try {
    setWorkerUrl(`${process.env.PUBLIC_URL || ""}/vendor/maplibre/maplibre-gl-worker.mjs`);
  } catch {
    /* older/newer build without setWorkerUrl – MapLibre falls back to its own resolution */
  }
};

ensureMapLibreWorker();
